import { render } from "./BlockCountdownEdit.vue?vue&type=template&id=b304d14e"
import script from "./BlockCountdownEdit.vue?vue&type=script&lang=js"
export * from "./BlockCountdownEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__